export const tableOption = {
  border: true,
  index: false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  showClomnuBtn: false,
  searchSize: 'mini',
  refreshBtn: false,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  labelWidth: 120,
  column: [{
    label: '分类词',
    prop: 'label',
    editDisabled: true,
    rules: [{
      required: true,
      message: '请输入分类词',
      trigger: 'blur'
    }, {
      min: 1,
      max: 100,
      message: '长度在 1 到 100 个字符',
      trigger: 'blur'
    }]
  }, {
    label: '分类词（英文）',
    prop: 'labelEn',
    editDisabled: true,
    rules: [{
      required: true,
      message: '请输入分类词（英文）',
      trigger: 'blur'
    }, {
      min: 1,
      max: 100,
      message: '长度在 1 到 100 个字符',
      trigger: 'blur'
    }]
  }, {
  //   label: '作用对象',
  //   prop: 'targetType',
  //   type: 'select',
  //   editDisabled: true,
  //   solt: true,
  //   rules: [{
  //     required: true,
  //     message: '请选择作用对象',
  //     trigger: 'blur'
  //   }],
  //   dicData: [{
  //     label: '内容',
  //     value: '0'
  //   }, {
  //     label: '评论',
  //     value: '1'
  //   }]
  // }, {
    label: '排序',
    prop: 'sort',
    type: 'number',
    rules: [{
      required: true,
      message: '请输入排序',
      trigger: 'blur'
    }]
  }, {
    label: '创建者',
    prop: 'createdBy',
    solt: true,
    addVisdiplay: false,
    editVisdiplay: false,
  }, {
    width: 180,
    label: '创建时间',
    prop: 'createTime',
    addVisdiplay: false,
    editVisdiplay: false,
  }]
}
